import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-auth-layout-simple',
  templateUrl: './auth-layout-simple.component.html',
  styleUrls: ['./auth-layout-simple.component.scss']
})
export class AuthLayoutSimpleComponent implements OnInit {
  year = new Date().getFullYear();
  constructor(private router: Router,) { }

  ngOnInit() {

  /*  const rol_id = localStorage.getItem('rol_id')

    if(rol_id == '1'){
      this.router.navigateByUrl('/requests');
    } else {
      if (rol_id == '2') {
        this.router.navigateByUrl('/customer');
      }else{
        this.router.navigateByUrl('/sessions/ses/signin');
     }
    }*/

  }

}
